import getStyle from './getStyle';

const centerElement = function (el, extra) {
    let width;
    let height;
    if (extra) {
        if (!extra.width) {
            throw '2nd args must have width value';
        }
        if (!extra.height) {
            throw '2nd args must have height value';
        }
        width = parseInt(extra.width);
        height = parseInt(extra.height);
    } else {
        // not required for now
        width = getStyle(el, 'width');
        height = getStyle(el, 'height');
    }
    const marginLeft = width / 2;
    const marginTop = height / 2;
    el.style.left = '50%';
    el.style.top = '50%';
    el.style.position = 'fixed';
    el.style.marginLeft = `-${marginLeft}px`;
    el.style.marginTop = `-${marginTop}px`;
};
export default centerElement;
